import script from "./Auth.vue?vue&type=script&setup=true&lang=ts"
export * from "./Auth.vue?vue&type=script&setup=true&lang=ts"

import "./Auth.vue?vue&type=style&index=0&id=3a862d0a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a862d0a"]])

export default __exports__